import { useSelector } from 'react-redux'

import findFP from 'lodash/fp/find'
import flow from 'lodash/fp/flow'
import getFP from 'lodash/fp/get'

import { AVAILABLE_CONTEXTS } from './duckContext'

export const getContextIdBySlug = (slug) => {
  switch (slug) {
    case AVAILABLE_CONTEXTS.root: return 1
    case AVAILABLE_CONTEXTS.company: return 2
    case AVAILABLE_CONTEXTS.farm: return 3
    case AVAILABLE_CONTEXTS.property: return 4
    default: return null
  }
}
export const getContextSlugById = (id) => {
  switch (id) {
    case 1: return AVAILABLE_CONTEXTS.root
    case 2: return AVAILABLE_CONTEXTS.company
    case 3: return AVAILABLE_CONTEXTS.farm
    case 4: return AVAILABLE_CONTEXTS.property
    default: return null
  }
}

export const selectCurrentContext = (state) => state.context.currentContext

export const selectCurrentContextId = (state) => getContextIdBySlug(state.context.currentContext)

export const selectContexts = state => state.context.contexts

export const useContextNameById = () => {
  const contexts = useSelector(selectContexts)

  return (contextId) => flow(
    findFP({ id: contextId }),
    getFP('name')
  )(contexts)
}

